/**
 * Auth event types for real-time notifications and durable event recording.
 */
export enum AuthEventType {
  USER_CREATED = 'auth:user-created',
  USER_UPDATED = 'auth:user-updated',
  USER_DELETED = 'auth:user-deleted',
  API_KEY_CREATED = 'auth:api-key-created',
  API_KEY_REVOKED = 'auth:api-key-revoked',
  /** DEV-006: emitted (durable + Redis `auth:events`) when an admin deactivates a user. */
  USER_DEACTIVATED = 'auth:user-deactivated',
  /** O0-B §4: emitted when an ephemeral access token is minted. */
  EPHEMERAL_TOKEN_ISSUED = 'auth:ephemeral-token-issued',
  /** Admin MFA STAGE A: a TOTP enrollment was confirmed (factor enabled). */
  MFA_ENROLLED = 'auth:mfa-enrolled',
  /** Admin MFA STAGE A: an enrollment confirmation code failed. */
  MFA_CONFIRM_FAILED = 'auth:mfa-confirm-failed',
  /** Admin MFA STAGE A: MFA challenge completed successfully. */
  MFA_LOGIN_SUCCESS = 'auth:mfa-login-success',
  /** Admin MFA STAGE A: a bad code / lockout on the MFA challenge step. */
  MFA_LOGIN_FAILED = 'auth:mfa-login-failed',
  /** Admin MFA STAGE A: a single-use recovery code spent at login. */
  MFA_RECOVERY_USED = 'auth:mfa-recovery-used',
  /** Admin MFA STAGE A: the factor was disabled for a user. */
  MFA_DISABLED = 'auth:mfa-disabled',
  /** STAGE B: an org-scoped session was switched in (policy-approved). */
  SESSION_ORG_SWITCHED = 'auth:session-org-switched',
  /** STAGE B: an org-scope switch or refresh reauthorization was denied. */
  SESSION_ORG_DENIED = 'auth:session-org-denied',
  /** STAGE B: an org-scoped session family was revoked (logout / scope loss). */
  SESSION_ORG_REVOKED = 'auth:session-org-revoked',
}

/**
 * Pub/sub channel for auth events.
 */
export const AUTH_EVENTS_CHANNEL = 'auth:events';
